import moment from 'moment';
import DateRangePicker from 'v3/common/components/DatePicker/index';
import useComponentVisible from '../../../hooks/useComponentVisible';

const RenderDatePicker = ({
  type,
  label,
  start,
  end,
  handleDateChange,
  calendarStartDate,
  calendarEndDate,
  selectedDate,
}: {
  type: 'start' | 'end';
  label: string;
  start: Date | null;
  end: Date | null;
  handleDateChange: (type: 'start' | 'end', date: Date, fn: () => void) => void;
  calendarStartDate: Date;
  calendarEndDate: Date;
  selectedDate: Date | null;
}) => {
  const { ref, isComponentVisible, setIsComponentVisible } = useComponentVisible(false);

  return (
    <>
      <div ref={ref} className="date-picker-item col-md-6 col-12">
        <span className="label mt-3">{label}</span>
        <div className="date-picker-input">{moment(selectedDate).format('DD-MM-YYYY') || 'Select Date'}</div>
        {isComponentVisible && (
          <DateRangePicker
            className={`${type}-date-picker`}
            startDate={start}
            endDate={end}
            onChange={(date: Date | null) =>
              date && handleDateChange(type, date, () => setIsComponentVisible(false))
            }
            minDate={calendarStartDate}
            maxDate={calendarEndDate}
            openToDate={selectedDate ?? undefined}
          />
        )}
      </div>
    </>
  );
};
export default RenderDatePicker;
